import React from "react";
import processImg from "../../../Assets/Home/process.png";

const OurPlans = () => {
  return (
    <div className=" bg-[#f5f0e8] px-4 sm:px-0 py-10 sm:py-12">
      <div className="text-center mb-5 sm:mb-20 font-krona">
        <h2
          className="mt-8 text-gray-900 font-extrabold text-2xl md:text-4xl lg:text-[45px]"
          style={{ letterSpacing: "-0.02em" }}
        >
          Goals And Expansion Plans
        </h2>
      </div>

      <div>
        <img
          src={processImg}
          alt="Our Process"
          className="h-auto w-full object-cover max-w-7xl mx-auto"
        />
      </div>
    </div>
  );
};

export default OurPlans;
